const state = {
  woBaoShow: false
}
const mutations = {
  WOBAO_SHOW: (state, woBaoShow) => {
    state.woBaoShow = woBaoShow
  }
}

export default {
  state,
  mutations
}
